"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _scene = require("./scene");
Object.keys(_scene).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _scene[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _scene[key];
    }
  });
});
var _contextWrapper = require("./contextWrapper");
Object.keys(_contextWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _contextWrapper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _contextWrapper[key];
    }
  });
});